// @flow

import React, { Component } from 'react';
import classnames from 'classnames';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { Button, Icon } from '@shopify/polaris';
import { CartMajor } from '@shopify/polaris-icons';

import { ADMIN_APP_ASSET_PATHS } from 'src/constants/assets';
import { getAssetURL } from 'src/helpers';
import View from 'src/assets/images/theme-setting/view.svg?react';

type Props = {
  checked: boolean
};

type ComposedProps = Props & WithI18nProps;

class SubLayout24 extends Component<ComposedProps> {
  render() {
    const { checked } = this.props;
    const SubLayoutClass = classnames('sub-layout-item', {
      active: checked
    });
    return (
      <div className={SubLayoutClass}>
        <div className="sub-layout-item__image">
          <img src={getAssetURL(ADMIN_APP_ASSET_PATHS?.themeSetting?.sample)} alt="sample" />

          <div className="sub-layout-item__action sub-layout-item__action--small sub-layout-item__action--top">
            <div className="btn-action btn-action--circle" style={{ marginBottom: '4px' }}>
              <Button outline>
                <Icon source={CartMajor} color="base" />
              </Button>
            </div>
            <div className="btn-action btn-action--circle">
              <Button outline>
                <View />
              </Button>
            </div>
          </div>
        </div>
        <div className="sub-layout-item__info">
          <p className="product-name">Small Naomi</p>
          <p className="product-vendor">PULL& PEAR</p>
          <p className="product-price">$485.00 CAD</p>
        </div>
      </div>
    );
  }
}

export default withI18n()(SubLayout24);
